'use client';

import './add-payment-method-form.scss';

import { FieldValues } from 'react-hook-form';

import { Form, useFormMethods } from '@sola/ark-core/molecules/form/form.js';

export type AddPaymentMethodFormProps = {
  formLabel: string;
  children?: React.ReactNode;
};

export const AddPaymentMethodForm: React.FC<AddPaymentMethodFormProps> = ({
  formLabel,
  children,
}) => {
  const formMethods = useFormMethods();
  const onSubmit = async (data: FieldValues) => {};

  return (
    <div className="AddPaymentMethodForm flex flex-col lg:flex-row w-full space-between gap-comfy-xl">
      <aside className="AddPaymentMethodForm__label">
        <h3 className="label-potent md:label-potent label-md md:label-lg">
          {formLabel}
        </h3>
      </aside>

      <div className="AddPaymentMethodForm__form w-full">
        <Form
          onSubmit={onSubmit}
          formMethods={formMethods}
          isCustomError
          noValidate
        >
          {children}
        </Form>
      </div>
    </div>
  );
};
